import { CheckCircleTwoTone, DollarOutlined } from '@ant-design/icons';
import { App, Button, Dropdown, Space } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { currencyOptions } from '#constants';
import UserService from '#services/UserService';
import { updateUser } from '#store/userData';

export const CurrencyDropdown = () => {
  const { notification } = App.useApp();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.userData);
  const currentCurrency = user.currency || 'UAH';

  const items = useMemo(
    () =>
      currencyOptions.map((opt) => ({
        icon:
          currentCurrency === opt.value ? (
            <CheckCircleTwoTone twoToneColor="#2371d7" />
          ) : (
            <span style={{ display: 'inline-block', width: 14 }} />
          ),
        key: opt.value,
        label: opt.label
      })),
    [currentCurrency]
  );

  const onClick = async ({ key }) => {
    if (key === currentCurrency) return;

    try {
      await UserService.switchCurrency(key);
      dispatch(updateUser({ ...user, currency: key }));
      notification.success({ message: t('Success') });
    } catch (e) {
      notification.error({
        description: e.response?.data?.error?.message || t('Unable to update'),
        message: t('Error')
      });
    }
  };

  return (
    <Dropdown
      arrow={{ pointAtCenter: true }}
      menu={{ items, onClick }}
      placement="bottomRight"
      trigger={['click']}
    >
      <Button style={{ marginRight: '16px' }}>
        <Space>
          <div style={{ alignItems: 'center', display: 'flex', gap: '5px' }}>
            <DollarOutlined />
            {currentCurrency}
          </div>
        </Space>
      </Button>
    </Dropdown>
  );
};
